import { render, staticRenderFns } from "./MesaNewConfig.vue?vue&type=template&id=df260e5c&scoped=true"
import script from "./MesaNewConfig.vue?vue&type=script&lang=js"
export * from "./MesaNewConfig.vue?vue&type=script&lang=js"
import style0 from "./MesaNewConfig.vue?vue&type=style&index=0&id=df260e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df260e5c",
  null
  
)

export default component.exports